<template>
  <v-card class="rounded-card pa-3" height="100%">
    <v-card-title class="pt-0 pb-0">
      <v-row>
        <v-col cols="12">
          <h3 class="text-center primary--text font-weight-black">ENCUESTA DE SATISFACCIÓN</h3><br>
          <h5 class="text-center primary--text" v-html="displayTitle"/>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text style="height: 60vh;" class="black-text font-weight-black">
      <v-row>
        <v-col cols="12">
          <v-form
            ref="form"
            lazy-validation
            class="text-center"
          >
            <v-card-text v-for="(item, key) in surveyQuestions" :key="key" style="padding-top: 0px; padding-bottom: 15px;">
              <h4 v-html="`${key +1} .- ${item.question}`"/>
              <div class="error--text font-weight-bold" v-if="item.required && !item.answer">*Campo obligatorio</div>
              <v-text-field v-model="item.answer" v-if="item.type==='string'" :required="item.required"/>
              <v-textarea outlined v-model="item.answer" rows="1" v-if="item.type==='text'"/>
              <v-rating
                v-if="item.type==='rating' || item.type ==='ratingZero'"
                v-model="item.answer"
                background-color="yellowRating"
                :length="Object.keys(item.values).length"
                x-large>
                <template v-slot:item="props">
                  <v-icon
                    large
                    :color="props.isFilled ? 'yellowRating' : ''"
                    v-text="`mdi-numeric-${item.type==='rating' ? props.index + 1 : props.index}-box`"
                    @click="props.click"
                  ></v-icon>
                </template>
              </v-rating>
          </v-card-text>
          </v-form>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text>
      <v-row class="text-center">
        <v-col cols="12">
          <v-btn
            @click="saveAnswers()"
            rounded
            large
            color="#5C9DF2"
            class="font-weight-black white--text">Enviar respuestas</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import SurveyAnswerService from '@/services/SurveyAnswerService'

export default {
  name: 'Survey',

  props: {
    surveyQuestions: {
      type: Array, default: () => []
    },

    surveyTitle: {
      type: String, default: () => ''
    }
  },

  data: () => ({
    isValid: false
  }),

  methods: {
    validate () {
      if (!this.$refs.form.validate()) {
        return
      }
      let missing = false
      for (const question of this.surveyQuestions) {
        if (question.required && !question.answer) {
          missing = true
        }
      }
      if (!missing) {
        this.isValid = true
      }
    },

    async saveAnswers () {
      await this.validate()
      if (this.isValid) {
        try {
          const loader = this.$loading.show()
          await SurveyAnswerService.saveAnswers({ surveyQuestions: this.surveyQuestions })
          loader.hide()
          this.$emit('onClose')
        } catch (error) {
          console.error(error)
          this.$swal('Error!', 'Acción no disponible de momento, intenta mas tarde', 'error')
        }
      } else {
        this.$swal('Error!', 'Revisa los campos obligatorios', 'error')
      }
    }
  },

  computed: {
    displayTitle () {
      return this.surveyTitle ? this.surveyTitle : 'Tu opinión es muy importante para nosotros, nos ayuda a mejorar nuestros servicios.'
    }
  }
}
</script>

<style scoped>
  .rounded-card { border-radius: 50px !important; }
  .black-text { color: black!important; }
</style>
